exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PhotoPopup-b70a5013{font-size:15px;line-height:22px;width:202px;display:flex}.PhotoPopup-b70a5013 .thumb-d027b80a{margin-right:10px}.PhotoPopup-b70a5013 .metaLabel-b8e6d478{margin-bottom:5px}.PhotoPopup-b70a5013 .metaValue-c0296eb1{font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"PhotoPopup": "PhotoPopup-b70a5013",
	"thumb": "thumb-d027b80a",
	"metaLabel": "metaLabel-b8e6d478",
	"metaValue": "metaValue-c0296eb1"
};